<div
    class="bg-primary-700 flex items-center justify-around rounded-3xl px-1 py-2 shadow-xl">
    <!-- HOME -->
    <a
        routerLink="/easy/dashboard/home"
        [routerLinkActiveOptions]="{ exact: true }"
        #homeActive="routerLinkActive"
        routerLinkActive
        [ngClass]="
            homeActive.isActive
                ? 'text-primary bg-white shadow-md'
                : 'text-white/80'
        "
        class="flex min-w-[60px] flex-col items-center justify-center gap-1 rounded-2xl p-2 font-bold transition-all duration-200">
        <i class="pi pi-home text-lg"></i>
        <span fontSpanish class="text-[11px] font-bold">{{
            'vendorDashboard.easyMode.easyMobileNav.home' | transloco
        }}</span>
    </a>

    <!-- APPOINTMENTS -->
    <a
        routerLink="/easy/dashboard/appointments"
        [routerLinkActiveOptions]="{ exact: true }"
        #appointmentsActive="routerLinkActive"
        routerLinkActive
        [ngClass]="
            appointmentsActive.isActive
                ? 'text-primary bg-white shadow-md'
                : 'text-white/80'
        "
        class="flex min-w-[60px] flex-col items-center justify-center gap-1 rounded-2xl p-2 font-bold transition-all duration-200">
        <i class="pi pi-calendar text-lg"></i>
        <span fontSpanish class="text-[11px] font-bold">{{
            'vendorDashboard.easyMode.easyMobileNav.appointments' | transloco
        }}</span>
    </a>

    <!-- MENU -->
    <button
        (click)="onMenuClick()"
        class="flex min-w-[54px] flex-col items-center justify-center gap-1 rounded-2xl border border-white/20 bg-white/10 px-1 py-2 font-bold text-white shadow-sm backdrop-blur-md transition-all duration-200 active:scale-95">
        <div class="flex items-center justify-center text-white">
            <i class="pi pi-bars text-sm"></i>
        </div>

        <span fontSpanish class="text-[11px] font-bold tracking-wide">{{
            'vendorDashboard.easyMode.easyMobileNav.menu' | transloco
        }}</span>
    </button>

    <!-- CALENDAR -->
    <a
        routerLink="/easy/dashboard/calendar"
        [routerLinkActiveOptions]="{ exact: true }"
        #calActive="routerLinkActive"
        routerLinkActive
        [ngClass]="
            calActive.isActive
                ? 'text-primary bg-white shadow-md'
                : 'text-white/80'
        "
        class="flex min-w-[60px] flex-col items-center justify-center gap-1 rounded-2xl p-2 transition-all duration-200">
        <i class="pi pi-calendar text-lg"></i>
        <span fontSpanish class="text-[11px] font-bold">{{
            'vendorDashboard.easyMode.easyMobileNav.calendar' | transloco
        }}</span>
    </a>

    <!-- CLIENTS -->
    <a
        routerLink="/easy/dashboard/clients"
        [routerLinkActiveOptions]="{ exact: true }"
        #profileActive="routerLinkActive"
        routerLinkActive
        [ngClass]="
            profileActive.isActive
                ? 'text-primary bg-white shadow-md'
                : 'text-white/80'
        "
        class="flex min-w-[60px] flex-col items-center justify-center gap-1 rounded-2xl p-2 transition-all duration-200">
        <i class="pi pi-users text-lg"></i>
        <span fontSpanish class="text-[11px] font-bold">{{
            'vendorDashboard.easyMode.easyMobileNav.clients' | transloco
        }}</span>
    </a>
</div>
